module.exports = __webpack_public_path__ + "media/images/illustration-4fa2c90f.png";